import React, { useEffect, useCallback } from "react";
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Button,
  FormHelperText,
} from "@mui/material";
import { Delete as DeleteIcon, Send as SendIcon } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { Form } from "react-final-form";

import { TextField } from "../common/Fields";
import { Content } from "../layout";
import { getOrg, submitOrg, updateOrg, deleteOrg } from "../../actions";

const OrganizationForm = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id } = useParams();

  const { organization } = useSelector((state) => state.org);

  useEffect(() => {
    if (id) {
      dispatch(getOrg(id));
    }
  }, [id, dispatch]);

  const onSubmit = useCallback(
    async ({ name, displayName }) => {
      const organization = {
        name,
        displayName,
        canHaveGateways: true,
      };
      const upsertOrg = new Promise((resolve, reject) => {
        if (id) {
          dispatch(updateOrg({ organization, id }))
            .then(() => resolve())
            .catch((error) => reject(error));
        } else {
          dispatch(submitOrg({ organization }))
            .then(() => resolve())
            .catch((error) => reject(error));
        }
      });

      try {
        await upsertOrg;
        navigate("/organizations");
      } catch (error) {
        let errors;
        if (error.response.data?.errors) {
          const arrayErrors = error.response.data.errors;
          arrayErrors.forEach((error) => {
            errors = { ...errors, [error.param]: error.msg };
          });
        }
        return errors;
      }
    },
    [id, dispatch, navigate]
  );

  const onDelete = useCallback(
    (e) => {
      e.preventDefault();
      if (window.confirm("삭제하시겠습니까?")) {
        dispatch(deleteOrg({ id }))
          .then(() => navigate("/organizations"))
          .catch((error) => alert(error));
      }
    },
    [id, dispatch, navigate]
  );

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{
        name: organization?.name,
        displayName: organization?.displayName,
      }}
      validate={(values) => {
        const errors = {};
        if (!values.name) {
          errors.name = "필수";
        }
        if (!values.displayName) {
          errors.displayName = "필수";
        }
        return errors;
      }}
      render={({
        submitError,
        handleSubmit,
        form,
        submitting,
        pristine,
        values,
      }) => (
        <Content>
          <form onSubmit={handleSubmit}>
            <Card>
              <CardContent>
                <Typography variant="h5" component="div">
                  건설사
                </Typography>

                <Grid
                  container
                  alignItems="flex-start"
                  spacing="20"
                  sx={{ mt: 2 }}
                >
                  <Grid item xs={12}>
                    <TextField
                      // required={true}
                      variant="standard"
                      name="name"
                      type="text"
                      label="구분값"
                      helperText="영문자, 숫자, '-'만 가능합니다."
                      inputProps={{
                        pattern: "[\\w-]+",
                      }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      // required={true}
                      variant="standard"
                      name="displayName"
                      type="text"
                      label="건설사 이름"
                    />
                  </Grid>
                </Grid>
              </CardContent>
            </Card>
            {submitError && <FormHelperText>{submitError}</FormHelperText>}
            <Grid container sx={{ mt: 2 }}>
              <Grid item xs={6}>
                {id && (
                  <Button
                    variant="outlined"
                    color="error"
                    startIcon={<DeleteIcon />}
                    onClick={onDelete}
                  >
                    삭제
                  </Button>
                )}
              </Grid>
              <Grid item xs={6} container justifyContent="flex-end">
                <Button
                  variant="contained"
                  endIcon={<SendIcon />}
                  type="submit"
                >
                  저장
                </Button>
              </Grid>
            </Grid>
          </form>
        </Content>
      )}
    />
  );
};

export default OrganizationForm;
